import { useEffect, useState } from "react";
import { dmaData } from "../../utils/minified-dma-data";
import { HdgTextInput } from "../hdg-text-input";
import { Button, Stack, SxProps } from "@mui/material";
import "./styles.scss";

export const DmaSearch = ({
  onSelect,
  label = "Search for a DMA by ZipCode",
  previewDma,
  onSearch,
  onResult,
  hideResult = false,
  sx,
}: {
  onSelect: ({ dma, zip }: { dma: string; zip: string }) => void;
  label?: string;
  previewDma?: string;
  onSearch?: (dma: { DMA: string }) => void;
  onResult?: (dma: string, zip: string) => void;
  hideResult?: boolean;
  sx?: SxProps;
}) => {
  const [search, setSearch] = useState<string>("");
  const [filteredDmaData, setFilteredDmaData] = useState<{ DMA: string }>();

  const handleSearch = (search: string) => {
    const dmaFromSearch = (dmaData as any)[search];
    setFilteredDmaData(dmaFromSearch);
    onSearch && onSearch(dmaFromSearch);
  };

  useEffect(() => {
    if (search.length === 5) {
      handleSearch(search);
    } else if (search.length < 5) {
      setFilteredDmaData(undefined);
    }
  }, [search]);

  useEffect(() => {
    if (previewDma && filteredDmaData?.DMA !== previewDma) {
      setSearch("");
      setFilteredDmaData({ DMA: previewDma });
      onResult && onResult(previewDma, search);
    }
  }, [previewDma, filteredDmaData, onResult, search]);

  const handleSelect = () => {
    onSelect({ dma: filteredDmaData?.DMA as string, zip: search });
    setSearch("");
    setFilteredDmaData(undefined);
  };

  return (
    <Stack className="dma-search" spacing={2}>
      <HdgTextInput
        value={search}
        onChange={(value) => setSearch(value)}
        label={label}
        sx={{ minWidth: 280 }}
        size="small"
        className="dma-search-input"
      />
      {!hideResult && filteredDmaData && (
        <Stack direction="column" spacing={2} className="dma-result">
          <Stack direction={"row"} spacing={2}>
            <p className="font-size-4">
              <b>Territory ID:</b> {filteredDmaData?.DMA}
            </p>
            {search.length > 0 && (
              <p className="font-size-4">
                <b>Territory Zip Code:</b> {search}
              </p>
            )}
          </Stack>
          <div>
            <Button
              variant="contained"
              disabled={!filteredDmaData}
              onClick={handleSelect}
              className="font-size-3"
            >
              Select this DMA
            </Button>
          </div>
        </Stack>
      )}
    </Stack>
  );
};
